import { Card } from "@/components/Shared/Card";
import { ProyectosTable } from "./ProyectosTable";
import { Separator } from "@/components/ui/separator";
import { NewProyectoModal } from "./NewProyecto/NewProyecto.modal";
import { useModalVoid } from "@/hooks/useModal";
import { Button } from "@/components/ui/button";
import { useApi } from "@/hooks/useApi";
import { useErrorMessage } from "@/hooks/useErrorMessage";

export function ProyectosDashboard() {
	const newProyectoModal = useModalVoid();

	const api = useApi();
	const { data, isPending, error } = api.useQuery("get", "/v1/Empresa/Proyectos", {});
	const errorMessage = useErrorMessage((_code) => null, error);	//Sin errores especificos.

	return (
		<Card>
			<h1 className="text-xl font-bold">Listado de Datos Anuales</h1>
			<Separator />
			<div className="flex justify-end">
				<Button variant="primary" onClick={newProyectoModal.open}>
					Nueva huella de producto
				</Button>
			</div>
			<NewProyectoModal
				shown={newProyectoModal.shown}
				close={newProyectoModal.close}
			/>
			<ProyectosTable rawData={data ?? []} isLoading={isPending} error={errorMessage} />
		</Card>
	);
}
